import { render, staticRenderFns } from "./SelectBirthDayParts.vue?vue&type=template&id=2ed2379e&scoped=true&lang=pug&"
import script from "./SelectBirthDayParts.vue?vue&type=script&lang=ts&"
export * from "./SelectBirthDayParts.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBirthDayParts.vue?vue&type=style&index=0&id=2ed2379e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2379e",
  null
  
)

export default component.exports